module.exports = __webpack_public_path__ + "static/t-bubble-0-15ab0611eb8df07fe7fad22c30004ae0.png";